import Chip, { chipClasses } from "@mui/material/Chip";
import styled from "@emotion/styled";

export const StyledChip = styled(Chip)(({ theme }) => ({
	color: theme.project.colors.primaryColors.main,
	fontWeight: "500",
	borderColor: theme.project.colors.primaryColors.main,
	width: "fit-content",
	[`& .${chipClasses.label}`]: {
		fontSize: "1rem"
	},
	[`& .${chipClasses.icon}`]: {
		color: theme.project.colors.primaryColors.main
	}
}));
